/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import { isNextJs, isServer } from 'tradera/utils/nextjs';

const slice = createSlice({
    name: 'random',
    initialState: {
        randomNumber: 0
    },
    reducers: {
        setRandomNumber: (state) => {
            if (isNextJs && !isServer) {
                throw new Error(
                    'setRandomNumber should only be called on the server'
                );
            }
            state.randomNumber = Math.random();
        }
    }
});

export const { setRandomNumber } = slice.actions;
export const reducer = slice.reducer;
